import { defineMessages } from "react-intl";

export default defineMessages({
  marketplaceError: {
    id: "cMov2n",
    defaultMessage: "Error loading apps marketplace",
    description: "error message",
  },
  marketplaceErrorMessage: {
    id: "F2cR19",
    defaultMessage: "Error details: {message}",
    description: "error message",
  },
});
